<template>
  <div ref="host" class="host vm-video-side">
    <div class="vm-video-side-header">
      <div class="vm-videochat-search-wrap">
        <input
          placeholder="Поиск..."
          v-model="searchControl"
          class="vm-videochat-search"
          type="text"
        />
      </div>
      <button @click="$emit('open')" class="vm-exit-button" v-b-tooltip.hover title="пригласить в комнату">	
        <i class="material-icons">person_add</i>	
      </button>
      <div class="vm-buttons">
        <button @click="toggleActive(!$store.state.chat.activeByVoice)" class="vm-action-button" v-b-tooltip.hover :title="!$store.state.chat.activeByVoice ? 'показывать говорящих': 'не показывать говорящих'">
                <i class="material-icons" :class="{'vm-red': !$store.state.chat.activeByVoice, 'vm-green': $store.state.chat.activeByVoice}">record_voice_over</i>
              </button>
        <button @click="toggleVideo()" class="vm-action-button" v-b-tooltip.hover title="видео">
          <i class="material-icons" :class="{'vm-red': !video }">
            {{ video ? 'videocam' : 'videocam_off' }}
          </i>
        </button>
        <button @click="toggleAudio()" class="vm-action-button" v-b-tooltip.hover title="микрофон">
          <i class="material-icons" :class="{'vm-red': !audio }">
            {{ audio ? 'mic' : 'mic_off' }}
          </i>
        </button>
        <button @click="toogleShareScreen()" class="vm-action-button" v-b-tooltip.hover title="поделиться экраном">
          <i class="material-icons" :class="{'vm-red': shareScreen }">
            {{ !shareScreen ? 'screen_share' : 'stop_screen_share' }}
          </i>
        </button>
      </div>
    </div>
    <div class="vm-video-side-main">
      <div class="vm-video-contacts">
        <VideoComponent
          v-for="frame in sources"
          @select="selectFrame(frame)"
          @mute="mute(frame)"
          :key="frame.streamManager.stream.connection.connectionId"
          :frame="frame"
        />
      </div>
      <div class="vm-video-viewer">
        <div class="vm-video-viewer-content">
          <div class="vm-video-frame" ref="mainframe">
            <VideoComponent large
              v-if="activeFrame"
              @mute="mute(activeFrame)"
              @exitFullscreen="toggleFullscreen"
              :fullscreen="fullscreen"
              :frame="activeFrame"
            />
          </div>
        </div>
        <div class="vm-video-viewer-footer">
          <div v-if="activeFrame.streamManager.remote" class="vm-video-control-block">
            <div class="vm-video-range">
              <i class="material-icons">volume_down</i>
              <b-form-input v-model="volume" type="range" min="0" max="100"></b-form-input>
              <i class="material-icons">volume_up</i>
            </div>
            <div class="vm-buttons">
              <button @click="toggleCam(activeFrame)" class="vm-action-button" v-b-tooltip.hover title="видео">
                <i class="material-icons">{{ !activeFrame.cam ? 'videocam' : 'videocam_off' }}</i>
              </button>
              <button @click="mute(activeFrame)" class="vm-action-button" v-b-tooltip.hover title="заглушить">
                <i class="material-icons">{{ !activeFrame.mute ? 'volume_mute' : 'volume_off' }}</i>
              </button>
              <button @click="toggleFullscreen" class="vm-action-button" v-b-tooltip.hover title="на весь экран">
                <i class="material-icons">fullscreen</i>
              </button>
              <button v-if="available()" @click="dropUser(activeFrame)" class="vm-action-button" v-b-tooltip.hover title="исключить из комнаты">
                <i class="material-icons">person_remove</i>
              </button>
            </div>
          </div>
          <div v-else class="vm-video-control-block">
            <div class="vm-buttons">
              <button @click="toggleVideo()" class="vm-action-button" v-b-tooltip.hover title="видео">
                <i class="material-icons" :class="{'vm-red': !video }">
                  {{ video ? 'videocam' : 'videocam_off' }}
                </i>
              </button>
              <button @click="toggleAudio()" class="vm-action-button" v-b-tooltip.hover title="микрофон">
                <i class="material-icons" :class="{'vm-red': !audio }">
                  {{ audio ? 'mic' : 'mic_off' }}
                </i>
              </button>
              <button @click="toogleShareScreen()" class="vm-action-button" v-b-tooltip.hover title="поделиться экраном">
                <i class="material-icons" :class="{'vm-red': shareScreen }">
                  {{ !shareScreen ? 'screen_share' : 'stop_screen_share' }}
                </i>
              </button>
              <button @click="toggleFullscreen" class="vm-action-button" v-b-tooltip.hover title="на весь экран">
                <i class="material-icons">fullscreen</i>
              </button>
              <button @click="dropUser(activeFrame)" class="vm-action-button" v-b-tooltip.hover title="выйти из комнаты">
                <i class="material-icons exit-room">login</i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoComponent from './VideoComponent';

export default {
  components: {
    VideoComponent
  },
  props: {
    frames: Array,
    activeFrame: Object
  },
  data: () => ({
    searchControl: null,
    fullscreen: false
  }),
  async mounted() {
    await this.$nextTick();
    this.$refs.mainframe.onfullscreenchange = event => this.fullscreen = !this.fullscreen;
  },
  computed: {
    sources() {
      return this.searchControl ?
        this.frames
          .filter(({ username }) => username.toLowerCase().indexOf(this.searchControl.toLowerCase()) > -1) : 
        this.frames;
    },
    volume: {
      get() {
        return this.$store.state.chat.mainFrame.volume;
      },
      set(value) {
        this.$store.commit('chat/updateMainFrameVolume', value);
      }
    },
    shareScreen() {
      return this.$store.state.chat.shareScreen;
    },
    audio() {
      return this.$store.state.chat.audio;
    },
    video() {
      return this.$store.state.chat.video;
    }
  },
  methods: {
    toggleActive(val) {
      this.$store.commit('chat/setActiveByVoice', val);
    },
    toggleCam(frame) {
      const { streamId } = frame.stream;
      this.$store.commit('chat/toggleCam', streamId);
    },
    mute(frame) {
      const { streamId } = frame.stream;
      this.$store.commit('chat/toggleMute', streamId);
    },
    toogleShareScreen() {
      if (this.shareScreen) {
        this.$store.dispatch('chat/stopShareScreen');
      } else {
        this.$store.dispatch('chat/shareScreen');
      }
    },
    selectFrame(frame) {
      this.$store.commit('chat/setMainFrame', frame);
    },
    toggleAudio() {
      if (this.audio) {
        this.$store.dispatch('chat/disableAudio');
      } else {
        this.$store.dispatch('chat/enableAudio');
      }
    },
    toggleVideo() {
      if (this.video) {
        this.$store.dispatch('chat/disableVideo');
      } else {
        this.$store.dispatch('chat/enableVideo');
      }
    },
    toggleFullscreen() {
      if (this.fullscreen) {
        document.exitFullscreen();
      } else {
        this.$refs.mainframe.requestFullscreen();
      }
    },
    dropUser(evt) {
      const data = { id: JSON.parse(evt.stream.connection.data).userId};
      this.$emit('drop-user', data);
    },
    available() {
      let isAvail = false;
      if (this.$store.state.permission.resources.organization) {
        Object.keys(this.$store.state.permission.resources.organization).forEach(obj => {
          isAvail = isAvail ? isAvail : this.$store.state.permission.resources.organization[obj].roles.includes('doctor');
          isAvail = isAvail ? isAvail : this.$store.state.permission.resources.organization[obj].roles.includes('employee');
          isAvail = isAvail ? isAvail : this.$store.state.permission.resources.organization[obj].roles.includes('orgadmin');
        });
      }
      return isAvail;
    }
  }
};
</script>

<style scoped>
.exit-room {
  transform: rotate(180deg);
}
.vm-red {
  color: rgb(252, 93, 93);
}
.vm-green {
  color: rgb(138, 252, 93);
}
.host.vm-video-side {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.vm-video-side-header {
  height: 60px;
  flex: 0 0 60px;
  display: flex;
  border-bottom: 1px solid rgba(255,255,255,.8);
}
.vm-video-side-main {
  height: calc(100% - 60px);
  display: flex;
}
.vm-video-contacts {
  /* background-color: red; */
  width: 150px;
  flex: 0 0 150px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
.vm-video-contacts-header {
  height: 60px;
  flex: 0 0 60px;
}
.vm-video-contacts-content {
  height: 100%;
  overflow-y: auto;
}
.vm-video-viewer {
  border-left: 1px solid rgba(255,255,255,.8);
  flex: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.vm-video-viewer-header {
  display: none;
}
.vm-video-viewer-footer {
  flex: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.vm-video-frame {
  display: flex;
  max-height: 100%;
}
.vm-video-side img {
  display: block;
  width: 100%;
}
/* scroll */
::-webkit-scrollbar {
  width: 10px;
}
::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.3);
}
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
}
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
/* header main */
.vm-video-contacts-header {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.vm-videochat-search-wrap {
  padding: 12px;
  padding-right: 0;
  width: 224px;
}
.vm-videochat-search {
  display: block;
  border: 0;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  width: 100%;
  color: #fff;
  padding-left: 24px;
  height: 36px;
  outline: none;
}
.vm-videochat-search::placeholder {
  color: #fff;
  font-weight: 300;
}
.vm-exit-button {
  border: 0;
  background-color: transparent;
  color: #fff;
  outline: 0;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 60px;
  margin-right: 24px;
}
.vm-exit-button i {
  font-size: 36px;
}
.vm-video-control-block {
  width: 100%;
  padding: 24px;
}
.vm-video-range {
  display: flex;
  width: 100%;
  align-items: center;
}
.vm-video-range i {
  margin: 12px;
  color: #fff;
}
input[type=range] {
  outline: 0;
}
input[type=range]::-webkit-slider-thumb {
  background-color: white;
  box-shadow: 0 0 5px 2px rgba(0,0,0,0.3);
}
.vm-buttons {
  display: flex;
  justify-content: center;
}
.vm-video-side-header {
  align-items: center;
}
.vm-video-side-header .vm-buttons {
  margin-left: auto;
}
.vm-video-side-header .vm-buttons .vm-action-button {
  height: 42px;
  width: 42px;
}
.vm-action-button {
  outline: 0;
  background-color: rgba(255,255,255,.1);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  height: 48px;
  width: 48px;
  margin: 6px;
}
.vm-video-viewer-content {
  flex: auto;
  overflow: hidden;
  max-height: 100%;
}
@media (max-width: 1280px) {
  .vm-video-side-header {
    height: 48px;
    flex: 0 0 48px;
  }
  .vm-video-side-main {
    height: calc(100% - 48px);
  }
  .vm-video-side-header .vm-buttons .vm-action-button {
    height: 32px;
    width: 32px;
  }
  .vm-video-side-header .vm-buttons .vm-action-button i {
    font-size: 18px;
  }
  .vm-videochat-search-wrap {
    padding: 0;
  }
  .vm-videochat-search {
    height: 32px;
  }
  .vm-exit-button {
    height: 32px;
    flex: 0 0 32px;
  }
  .vm-exit-button i {
    font-size: 32px;
  }
}
</style>
